export default __webpack_public_path__ + "static/media/arrowLeft.d064fd0e.svg";